const brightColors = ['#FFB469', '#FFC709'];

export const useResolveBannerColors = (color: string) => {
  const fg = brightColors.includes(color) ? '#000' : '#fff';
  return { bg: color, fg };
};
